// extracted by mini-css-extract-plugin
export default {"diceCircle":"styles_diceCircle__I8pha"};